var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"mian-info"},[_vm._t("video-box"),_c('div',{staticClass:"img"},[_vm._t("img")],2),_c('div',{staticClass:"info"},[_c('h2',[_vm._v(_vm._s(_vm.title))]),_c('div',[_vm._t("content")],2)])],2)
}
var staticRenderFns = []

export { render, staticRenderFns }